import { SvgSprite } from './modules/svg-loader';

new SvgSprite('/Static/img/adage-sprite.svg');
